export type GenericProductPotency = {
  unit: string;
  range: number[] | null;
};

export type GenericBrand = {
  name: string;
  image: string | null;
  description: string | null;
};

export enum GenericStrainType {
  hybrid = 'Hybrid',
  sativa = 'Sativa',
  indica = 'Indica',
  highCbd = 'High CBD',
  seed = 'Seed',
  nA = 'N/A',
}

export enum GenericEffect {
  body = 'Body',
  calm = 'Calm',
  clearMind = 'Clear_Mind',
  comfort = 'Comfort',
  creative = 'Creative',
  energetic = 'Energetic',
  euphoric = 'Euphoric',
  focused = 'Focused',
  happy = 'Happy',
  inspired = 'Inspired',
  medicinal = 'Medicinal',
  mind = 'Mind',
  painRelief = 'Pain_Relief',
  relaxed = 'Relaxed',
  skinHealth = 'Skin_Health',
  sleepy = 'Sleepy',
  uplifted = 'Uplifted',
  joints = 'Joints',
  muscles = 'Muscles',
}

export type GenericPriceOption = {
  price: number;
  weight: string;
};
